(() => {
  const DESKTOP_QUERY = "(min-width: 990px)";
  const DESKTOP_THRESHOLD = 0.8; // 80%

  function getScrollProgress() {
    const doc = document.documentElement;
    const scrollTop = window.pageYOffset || doc.scrollTop || 0;
    const scrollHeight = doc.scrollHeight || 0;
    const clientHeight = doc.clientHeight || window.innerHeight || 0;
    const maxScroll = Math.max(scrollHeight - clientHeight, 1);
    return scrollTop / maxScroll;
  }

  function getMainAtcButton() {
    return (
      document.querySelector(
        '.ss-main-product .product-form__submit:not(.custom-sticky-atc__button)'
      ) ||
      Array.from(
        document.querySelectorAll(
          'product-form button[name="add"], product-form button[type="submit"]'
        )
      ).find((button) => !button.closest("#custom-sticky-atc-root")) ||
      null
    );
  }

  function getReviewsAnchor() {
    return (
      document.querySelector("#judgeme_product_reviews") ||
      document.querySelector(".jdgm-rev-widg") ||
      document.querySelector("[data-judgeme-reviews]") ||
      document.querySelector(".jdgm-widget.jdgm-review-widget")
    );
  }

  function shouldShowOnMobile(root) {
    // No mobile sticky ATC for an unavailable selected variant.
    const variants = root?.__ssVariants || parseVariants(root);
    const selectedId = getMainVariantId(root);
    const selectedVariant = variants.find(
      (variant) => String(variant.id) === String(selectedId)
    );

    if (!selectedVariant || !selectedVariant.available) return false;

    // Show around the point where the customer reaches the reviews.
    const reviews = getReviewsAnchor();
    if (!reviews) return false;

    const rect = reviews.getBoundingClientRect();

    // Trigger when the top of the review section reaches roughly
    // the lower quarter of the viewport, then keep showing below it.
    return rect.top <= window.innerHeight * 0.78;
  }

  function ensureMobileVariantLabel(root) {
    let label = root.querySelector("[data-sticky-atc-mobile-variant]");
    if (label) return label;

    const right = root.querySelector(".custom-sticky-atc__right");
    if (!right) return null;

    label = document.createElement("div");
    label.className = "custom-sticky-atc__mobile-variant";
    label.setAttribute("data-sticky-atc-mobile-variant", "");
    label.setAttribute("aria-live", "polite");

    right.insertBefore(label, right.firstChild);
    return label;
  }

  function setMobileVariantLabel(root, variant) {
    const label = ensureMobileVariantLabel(root);
    if (!label || !variant) return;

    label.textContent =
      variant.public_title ||
      variant.title ||
      (Array.isArray(variant.options) ? variant.options.join(" / ") : "");
  }

  function getMainVariantId(root) {
    const variants = root?.__ssVariants || parseVariants(root);

    // New Short Supply product page:
    // derive the selected variant directly from the checked option buttons.
    const newPicker = document.querySelector(".ss-main-product variant-selects");
    if (newPicker && variants.length) {
      const checked = Array.from(
        newPicker.querySelectorAll(
          '.product-form__input input[type="radio"]:checked'
        )
      );

      if (checked.length) {
        const selectedOptions = checked.map((input) => String(input.value || ""));

        const matchedVariant = variants.find((variant) => {
          const options = Array.isArray(variant.options) ? variant.options.map(String) : [];
          return (
            options.length === selectedOptions.length &&
            options.every((option, index) => option === selectedOptions[index])
          );
        });

        if (matchedVariant?.id) return String(matchedVariant.id);
      }
    }

    // Prefer the actual main product form inside the custom Short Supply product page.
    const scopedMainForm = document.querySelector(
      '.ss-main-product product-form form[action^="/cart/add"]'
    );
    const scopedVariantInput =
      scopedMainForm?.querySelector('input[name="id"]') ||
      document.querySelector(
        '.ss-main-product input[name="id"].product-variant-id'
      );

    if (scopedVariantInput?.value) return String(scopedVariantInput.value);

    // Fallback for the original product page.
    const forms = Array.from(
      document.querySelectorAll('product-form form[action^="/cart/add"]')
    );
    const mainForm = forms.find(
      (form) => !form.closest("#custom-sticky-atc-root")
    );

    const mainVariantInput =
      mainForm?.querySelector('input[name="id"]') ||
      document.querySelector(
        'input[name="id"].product-variant-id:not([data-sticky-atc-variant-id])'
      );

    return mainVariantInput?.value ? String(mainVariantInput.value) : "";
  }

  function isCartDrawerOpen() {
    if (document.body.classList.contains("overflow-hidden")) return true;
    const drawer = document.querySelector("cart-drawer");
    if (drawer && drawer.hasAttribute("open")) return true;
    const activeDrawer = document.querySelector(".drawer.active, .drawer--active");
    if (activeDrawer) return true;
    return false;
  }

  function isMobileMenuOpen() {
    const menuDetails = document.querySelector("#Details-menu-drawer-container");
    if (!menuDetails) return false;

    if (menuDetails.hasAttribute("open")) return true;

    const menuSummary = menuDetails.querySelector(
      ".header__icon--menu[aria-expanded='true']"
    );
    if (menuSummary) return true;

    return false;
  }

  function setButtonState(root, { available, atcLabel, soldoutLabel }) {
    const btn = root.querySelector(".custom-sticky-atc__button");
    if (!btn) return;

    if (!available) {
      btn.setAttribute("disabled", "disabled");
      btn.textContent = soldoutLabel || "SOLD OUT";
      btn.setAttribute("aria-disabled", "true");
    } else {
      btn.removeAttribute("disabled");
      btn.textContent = atcLabel || "ADD TO CART";
      btn.removeAttribute("aria-disabled");
    }
  }

  function parseVariants(root) {
    const script = root.querySelector("[data-sticky-atc-variants]");
    if (!script) return [];
    try {
      const v = JSON.parse(script.textContent || "[]");
      return Array.isArray(v) ? v : [];
    } catch (e) {
      return [];
    }
  }

  function normalizeImageUrl(url, width) {
    if (!url) return "";
    let u = String(url).trim();

    // Zorg dat protocol er netjes op zit
    if (u.startsWith("//")) u = "https:" + u;

    // Voeg width param toe als die er nog niet op zit
    if (width) {
      const hasWidth = /[?&]width=\d+/i.test(u);
      if (!hasWidth) {
        u += (u.includes("?") ? "&" : "?") + "width=" + String(width);
      }
    }

    return u;
  }

  function getVariantImageSrc(variant) {
    if (!variant) return "";

    // Meest voorkomend in product.variants | json
    const fi = variant.featured_image;
    if (fi && (fi.src || fi.url)) return fi.src || fi.url;

    // Nieuwere structuren
    const fm = variant.featured_media;
    const pi = fm && fm.preview_image;
    if (pi && (pi.src || pi.url)) return pi.src || pi.url;

    // Soms staat er direct een image veld
    if (variant.image && (variant.image.src || variant.image.url)) {
      return variant.image.src || variant.image.url;
    }

    return "";
  }

  function initStickyImageState(root) {
    const img = root.querySelector(".custom-sticky-atc__image img");
    if (!img) return;

    if (!root.__ssDefaultImg) {
      root.__ssDefaultImg = {
        src: img.getAttribute("src") || "",
        alt: img.getAttribute("alt") || "",
      };
    }
  }

  function setStickyImage(root, variant) {
    const img = root.querySelector(".custom-sticky-atc__image img");
    if (!img) return;

    initStickyImageState(root);

    const rawSrc = getVariantImageSrc(variant);
    const src = normalizeImageUrl(rawSrc, 128);

    if (src) {
      img.setAttribute("src", src);

      const alt =
        (variant && (variant.name || variant.public_title || variant.title)) ||
        (root.__ssDefaultImg?.alt || "");
      if (alt) img.setAttribute("alt", alt);
    } else if (root.__ssDefaultImg?.src) {
      // fallback
      img.setAttribute("src", root.__ssDefaultImg.src);
      if (root.__ssDefaultImg.alt) img.setAttribute("alt", root.__ssDefaultImg.alt);
    }
  }

  async function addToCartAjax(variantId, quantity) {
    const body = new URLSearchParams();
    body.set("id", String(variantId));
    body.set("quantity", String(quantity || 1));

    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
      body,
      credentials: "same-origin",
    });

    if (!res.ok) {
      let errText = "";
      try {
        const j = await res.json();
        errText = j?.description || j?.message || "";
      } catch (_) {}
      throw new Error(errText || "Add to cart failed");
    }

    return res.json();
  }

  async function fetchCartAjax() {
    const res = await fetch("/cart.js", {
      method: "GET",
      headers: { Accept: "application/json" },
      credentials: "same-origin",
    });
    if (!res.ok) return null;
    try {
      return await res.json();
    } catch (_) {
      return null;
    }
  }

  function notifyThemeCartUpdated(cart) {
    try {
      document.dispatchEvent(new CustomEvent("cart:refresh"));
    } catch (_) {}

    try {
      document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart } }));
    } catch (_) {}

    try {
      document.dispatchEvent(new CustomEvent("cart:change", { detail: { cart } }));
    } catch (_) {}

    try {
      if (window.PUB_SUB_EVENTS && window.publish) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: "custom-sticky-atc" });
      }
    } catch (_) {}
  }

  function openCartDrawerBestEffort() {
    const bubble =
      document.querySelector("a#cart-icon-bubble") ||
      document.querySelector('a[href="/cart"][id*="cart"], a[href="/cart"].header__icon') ||
      document.querySelector('a[href="/cart"].link');

    if (bubble) {
      bubble.click();
      return;
    }

    const drawer = document.querySelector("cart-drawer");
    if (drawer) {
      drawer.setAttribute("open", "");
      return;
    }

    window.location.href = "/cart";
  }

  function bindSizeSelect(root) {
    const select = root.querySelector("[data-sticky-atc-size]");
    const variantInput = root.querySelector("[data-sticky-atc-variant-id]");
    const stickyBtn = root.querySelector(".custom-sticky-atc__button");
    if (!select || !variantInput || !stickyBtn) return;

    const variants = parseVariants(root);
    if (!variants.length) return;

    const atcLabel = stickyBtn.dataset.atcLabel || "ADD TO CART";
    const soldoutLabel = stickyBtn.dataset.soldoutLabel || "SOLD OUT";

    select.innerHTML = variants
      .map((v) => {
        const label = v.public_title || v.title || "Variant";
        return `<option value="${v.id}">${label}</option>`;
      })
      .join("");

    const setToId = (id) => {
      const idStr = String(id || "");
      if (!idStr) return false;

      const v = variants.find((x) => String(x.id) === idStr);
      if (!v) return false;

      select.value = idStr;
      variantInput.value = idStr;

      setButtonState(root, { available: !!v.available, atcLabel, soldoutLabel });
      setStickyImage(root, v);
      setMobileVariantLabel(root, v);

      return true;
    };

    // init: pak main variant of fallback
    const mainId = getMainVariantId(root);
    const firstAvailable = variants.find((v) => v.available);
    const fallbackId = String((firstAvailable || variants[0]).id);
    setToId(mainId || fallbackId);

    // Flags om te voorkomen dat sync jouw widget keuze terugzet
    root.__ssUserTouched = false;
    root.__ssLastSyncedMainId = "";

    const syncFromMainOnceWhenShown = () => {
      if (root.__ssUserTouched) return;
      const newMainId = getMainVariantId(root);
      if (!newMainId) return;
      if (newMainId === root.__ssLastSyncedMainId) return;

      if (setToId(newMainId)) {
        root.__ssLastSyncedMainId = newMainId;
      }
    };

    const syncFromMainIfNotTouched = () => {
      if (root.__ssUserTouched) return;
      const newMainId = getMainVariantId(root);
      if (!newMainId) return;

      if (setToId(newMainId)) {
        root.__ssLastSyncedMainId = newMainId;
      }
    };

    const scopedMainForm = document.querySelector(
      '.ss-main-product product-form form[action^="/cart/add"]'
    );

    const fallbackForms = Array.from(
      document.querySelectorAll('product-form form[action^="/cart/add"]')
    );

    const mainForm =
      scopedMainForm ||
      fallbackForms.find(
        (form) => !form.closest("#custom-sticky-atc-root")
      );

    const mainVariantInputEl =
      mainForm?.querySelector('input[name="id"]') ||
      document.querySelector(
        '.ss-main-product input[name="id"].product-variant-id'
      ) ||
      document.querySelector(
        'input[name="id"].product-variant-id:not([data-sticky-atc-variant-id])'
      );

    if (mainVariantInputEl) {
      mainVariantInputEl.addEventListener("change", syncFromMainIfNotTouched);
      mainVariantInputEl.addEventListener("input", syncFromMainIfNotTouched);
    }

    // New Short Supply variant picker.
    // Delegated listener keeps working even if Shopify replaces picker markup.
    document.addEventListener("change", (event) => {
      if (
        event.target?.matches(
          '.ss-main-product variant-selects .product-form__input input[type="radio"]'
        )
      ) {
        window.requestAnimationFrame(syncFromMainIfNotTouched);
      }
    });

    document.addEventListener("variant:change", syncFromMainIfNotTouched);
    document.addEventListener("variantChange", syncFromMainIfNotTouched);

    const onWidgetPick = () => {
      root.__ssUserTouched = true;

      const newId = String(select.value || "");
      if (newId) variantInput.value = newId;

      const v = variants.find((x) => String(x.id) === newId);
      if (v) {
        setButtonState(root, { available: !!v.available, atcLabel, soldoutLabel });
        setStickyImage(root, v);
        setMobileVariantLabel(root, v);
      }
    };

    select.addEventListener("change", onWidgetPick);
    select.addEventListener("input", onWidgetPick);
    select.addEventListener("click", onWidgetPick);

    root.__ssVariants = variants;
    root.__ssSyncFromMainOnceWhenShown = syncFromMainOnceWhenShown;
  }

  function bindATCSubmit(root) {
    const stickyForm = root.querySelector(".custom-sticky-atc__form");
    const stickyBtn = root.querySelector(".custom-sticky-atc__button");
    const select = root.querySelector("[data-sticky-atc-size]");
    if (!stickyForm || !stickyBtn || !select) return;

    stickyForm.addEventListener(
      "submit",
      async (e) => {
        e.preventDefault();

        if (stickyForm.dataset.ssSubmitting === "1") return;
        stickyForm.dataset.ssSubmitting = "1";

        const submitBtn = stickyForm.querySelector('button[name="add"], button[type="submit"]');
        if (submitBtn) submitBtn.setAttribute("disabled", "disabled");

        const unlock = () => {
          window.setTimeout(() => {
            stickyForm.dataset.ssSubmitting = "0";
            if (submitBtn) submitBtn.removeAttribute("disabled");
          }, 800);
        };

        if (stickyBtn.hasAttribute("disabled")) {
          unlock();
          return;
        }

        const chosenId = String(select.value || "");
        if (!chosenId) {
          unlock();
          return;
        }

        try {
          await addToCartAjax(chosenId, 1);

          const cart = await fetchCartAjax();
          notifyThemeCartUpdated(cart);

          openCartDrawerBestEffort();
        } catch (err) {
          unlock();
          return;
        } finally {
          unlock();
        }
      },
      true
    );
  }

  function init() {
    const root = document.getElementById("custom-sticky-atc-root");
    if (!root) return;

    initStickyImageState(root);

    const mq = window.matchMedia(DESKTOP_QUERY);

    let wasVisible = false;

    const applyVisibility = () => {
      if (isCartDrawerOpen() || isMobileMenuOpen()) {
        root.setAttribute("hidden", "");
        wasVisible = false;
        return;
      }

      const isDesktop = mq.matches;
      const shouldShow = isDesktop
        ? getScrollProgress() >= DESKTOP_THRESHOLD
        : shouldShowOnMobile(root);

      if (shouldShow) {
        root.removeAttribute("hidden");

        if (!wasVisible) {
          root.__ssUserTouched = false;
          if (typeof root.__ssSyncFromMainOnceWhenShown === "function") {
            root.__ssSyncFromMainOnceWhenShown();
          }
        }

        wasVisible = true;
      } else {
        root.setAttribute("hidden", "");
        wasVisible = false;
      }
    };

    let ticking = false;
    const onScrollOrResize = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        ticking = false;
        applyVisibility();
      });
    };

    mq.addEventListener?.("change", applyVisibility);
    window.addEventListener("scroll", onScrollOrResize, { passive: true });
    window.addEventListener("resize", onScrollOrResize);

    const mo = new MutationObserver(() => applyVisibility());
    mo.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class", "open", "aria-expanded"],
      subtree: true
    });
    mo.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"]
    });

    bindSizeSelect(root);
    bindATCSubmit(root);

    applyVisibility();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
